export default __webpack_public_path__ + "static/media/card-subscriptions.a8c510a0.png";